import React from 'react';
import { Dialog } from '@blueprintjs/core';
import classNames from 'classnames';
import { Icon, Text } from 'components';
import { useModal } from 'providers/modalProvider';
import { formatDateTime } from 'utils/helpers';

const StatusHistoryItem = ({ item, isCurrent }) => {
  const { status, version, createdAt } = item;

  return (
    <div
      className={classNames('status-history-item', {
        'is-current': isCurrent,
      })}
    >
      <div className="status-history-left">
        <div className="status-icon">
          {isCurrent ? (
            <Icon icon="tick-circle" size={20} className="current-icon" />
          ) : (
            <Icon icon="time" size={20} className="history-icon" />
          )}
        </div>
        <div className="status-info">
          <Text variant="body1" className="status-name">
            {status?.replace(/_/g, ' ') || 'Unknown'}
          </Text>
          <Text variant="body2" className="status-version">
            {`v${version}`}
          </Text>
        </div>
      </div>
      <div className="status-history-right">
        {isCurrent && <span className="current-badge">CURRENT</span>}
        <Text variant="body2" className="status-date">
          {formatDateTime(createdAt)}
        </Text>
      </div>
    </div>
  );
};

const StatusHistoryModal = () => {
  const { modalDispatch, modalState } = useModal();

  const { versions = [] } = modalState?.payload || {};

  const closeModal = () => {
    modalDispatch({ type: 'ClOSE_ALL' });
  };

  const dialogTitle = (
    <div className="modal-title">
      <Icon icon="history" size={20} />
      <span>Completion Version History</span>
    </div>
  );

  return (
    <Dialog
      isOpen={modalState?.open}
      title={dialogTitle}
      onClose={closeModal}
      canOutsideClickClose={false}
      className="status-history-modal"
      style={{ maxWidth: '90vw' }}
    >
      <div className="status-history-content">
        <div className="status-history-list mgt-21 mgl-32 mgr-32 mgb-21">
          {versions.map((item, index) => (
            <StatusHistoryItem
              key={`v${item.version}`}
              item={item}
              isCurrent={index === 0}
            />
          ))}
          {versions.length === 0 && (
            <Text variant="body1" className="no-history">
              No version history available.
            </Text>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default StatusHistoryModal;
